import { Base } from '@app/shared/models/base.model'
import { User } from '@app/modules/user/user.model'

export class Product extends Base {
  uuid: string = null
  name: string = null
  description: string = null
  code: string = null
  type: string = null
  displayOrder: number = null
  // ---------------------------------------------------------------------------
  createdAt: Date = null
  updatedAt: Date = null
  deletedAt: Date = null
  createdByUuid: string = null
  createdByUser: User = null
  updatedByUuid: string = null
  updatedByUser: User = null

  /**
   * Properties with type Date
   *
   * @type {Array<string>}
   */
  protected _dates: Array<string> = [
    'createdAt',
    'updatedAt',
    'deletedAt'
  ]

  /**
   * Constructor
   *
   * @param {Partial<Product>} data Initial values
   */
  public constructor (data?: Partial<Product>) {
    super(data)
    this.init(data)
  }
}
